/*
  ?purchase=onetime  – opens the product page with the one-time purchase preselected.
  Used by the Google Shopping feed (Channable): the ad shows the one-time price, so the
  landing page must show the same offer (see snippets/meta-tags.liquid and product-ld.liquid).

  Works with both picker families:
  - card pickers (simplified-v1 / menobacs): clicks the one-time card of the URL variant
  - "Abo / Einmalkauf" toggle pickers: clicks "Einmalkauf" and keeps the URL variant selected
  If the URL variant has no one-time option (e.g. 30 caps on card pickers), nothing changes:
  we never switch the customer to a different size than the one advertised.

  No flash: snippets/meta-tags.liquid adds html.mb-onetime-pending in <head> (before first
  paint), which hides the picker and the add-to-cart button until this script has switched.
  Card pickers select the one-time card natively (init() is patched in meta-tags.liquid);
  here we only verify it and fall back to a click.
  The pickers are custom elements that are defined only after DOMContentLoaded, so we wait
  for their definition (customElements.whenDefined) instead of window.load - clicking
  earlier does nothing, waiting for load causes the visible delay.
  A short-lived guard switches back if other picker code re-selects the subscription
  afterwards (until the customer interacts with the picker themselves).
  Failsafes: the head snippet removes the class after 4s; this script after 3.5s.
*/
(function () {
  var params;
  try {
    params = new URLSearchParams(window.location.search);
  } catch (e) {
    return;
  }
  var purchase = (params.get('purchase') || '').toLowerCase();
  if (purchase !== 'onetime' && purchase !== 'onetimer') return;

  var variantId = params.get('variant') || '';
  var html = document.documentElement;
  var revealed = false;
  var started = false;

  function reveal() {
    if (revealed) return;
    revealed = true;
    html.classList.remove('mb-onetime-pending');
  }

  function root() {
    return document.querySelector('main') || document;
  }

  // Resolves once the custom element `el` belongs to is defined (= its click handlers exist).
  function whenReady(el, cb) {
    var tag = el && el.localName;
    if (!tag || tag.indexOf('-') === -1 || !window.customElements || customElements.get(tag)) {
      return cb();
    }
    var done = false;
    function go() {
      if (done) return;
      done = true;
      setTimeout(cb, 0); // let connectedCallback / init finish first
    }
    customElements.whenDefined(tag).then(go);
    setTimeout(go, 3000);
  }

  // Click `target` until `isActive()` is true (max ~1s), then call `after`.
  function clickUntilActive(target, isActive, after) {
    var tries = 0;
    (function attempt() {
      if (isActive()) return after(true);
      if (tries++ >= 10) return after(false);
      target.click();
      setTimeout(attempt, 100);
    })();
  }

  function handleCards(r) {
    var cards = r.querySelectorAll('.menobacs-card[data-type="onetimer"]');
    if (!cards.length) return false;
    var card = null;
    for (var i = 0; i < cards.length; i++) {
      if (!variantId || cards[i].getAttribute('data-variant-id') === variantId) {
        card = cards[i];
        break;
      }
    }
    if (!card) {
      reveal();
      return true;
    }
    whenReady(card.closest('plan-picker-menobacs, plan-picker-menobacs-es') || card.parentElement, function () {
      clickUntilActive(
        card,
        function () {
          return card.classList.contains('active');
        },
        reveal
      );
    });
    return true;
  }

  function handlePill(r) {
    var pill = r.querySelector('.plan-button[data-type="onetimer"]');
    if (!pill) return false;
    var info = variantId
      ? r.querySelector('.option__info[data-type="onetimer"][data-variant-id="' + variantId + '"]')
      : null;
    if (variantId && !info) {
      reveal();
      return true;
    }
    whenReady(pill.closest('variant-selects') || pill.parentElement, function () {
      var changed = !pill.classList.contains('active');
      clickUntilActive(
        pill,
        function () {
          return pill.classList.contains('active');
        },
        function () {
          if (info) {
            var label = info.closest('label');
            var radio = label && label.htmlFor ? document.getElementById(label.htmlFor) : null;
            if (radio && !radio.checked) {
              label.click();
              changed = true;
            }
          }
          if (changed) revealAfterButtonUpdate();
          else reveal();
        }
      );
    });
    return true;
  }

  // Toggle pickers reload price + button from Shopify after the switch:
  // keep them hidden until the button text updates (max 1s), so the old price never shows.
  function revealAfterButtonUpdate() {
    var btn = root().querySelector('form[action*="/cart/add"] [type="submit"], form[action*="/cart/add"] [name="add"]');
    if (!btn || !window.MutationObserver) return reveal();
    var observer = new MutationObserver(function () {
      observer.disconnect();
      reveal();
    });
    observer.observe(btn, { childList: true, subtree: true, characterData: true });
    setTimeout(function () {
      observer.disconnect();
      reveal();
    }, 1000);
  }

  function run() {
    var r = root();
    return handleCards(r) || handlePill(r);
  }

  // Some picker code re-applies the URL variant's subscription card later on
  // (e.g. the inline sync in product-plan-picker-simplified-v1.liquid runs again at
  // DOMContentLoaded). Until the customer touches the picker themselves, switch back
  // to the one-time option whenever that happens. Stops 5s after window load.
  function guard() {
    if (!window.MutationObserver) return;
    var stopped = false;
    var observer = new MutationObserver(function () {
      if (stopped || window.__mbOnetimeUserTookOver) return;
      var r = root();
      var card = variantId && r.querySelector('.menobacs-card[data-type="onetimer"][data-variant-id="' + variantId + '"]');
      if (card) {
        if (!card.classList.contains('active')) card.click();
        return;
      }
      var pill = r.querySelector('.plan-button[data-type="onetimer"]');
      var info = variantId && r.querySelector('.option__info[data-type="onetimer"][data-variant-id="' + variantId + '"]');
      if (pill && (info || !variantId) && !pill.classList.contains('active')) pill.click();
    });
    observer.observe(root(), { attributes: true, attributeFilter: ['class'], subtree: true });
    function stop() {
      setTimeout(function () {
        stopped = true;
        observer.disconnect();
      }, 5000);
    }
    if (document.readyState === 'complete') stop();
    else window.addEventListener('load', stop);
  }

  function start() {
    if (started) return;
    started = true;
    setTimeout(reveal, 3500);
    guard();
    if (run()) return;
    // Picker not in the page yet: retry briefly, then show the page as is.
    var attempts = 0;
    var interval = setInterval(function () {
      if (run() || ++attempts > 20) {
        clearInterval(interval);
        if (attempts > 20) reveal();
      }
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
